import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import CssBaseline from '@mui/material/CssBaseline';
import { Experimental_CssVarsProvider as ThemeVarProvider } from '@mui/material/styles';
import React, { Suspense, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Observable } from 'windowed-observable';
import { reactPlugin } from './AppInsights';
import { AppRoutes } from './AppRoutes';
import CustomErrorBoundary from './ErrorHandling/CustomErrorBoundary';
import GlobalDataLayer from './components/GoogleTagManager/GlobalDataLayer';
import LoginTracking from './components/GoogleTagManager/LoginTracking';
import { GlobalStateContextProvider, useGlobalStateContext, } from './context/GlobalStateContext/GlobalStateContext';
import i18n from './i18n';
import { LoadingPage } from './pages/LoadingPage/LoadingPage';
import { NavigationManager } from './routing/NavigationManager';
import { Theme } from './themes/Theme';
import { isDeviceTouch } from './utils/browser-helpers';
import { isDev, isQA } from './utils/general-helpers';
import useScrollTo from './utils/scrollTo';
const observable = new Observable('globalState');
const initialState = {
    isAuthenticated: false,
    merchantUpdated: null,
    merchant: { number: undefined, name: '' },
    md2Info: undefined,
    merchantList: [],
    displaySnackBar: false,
    snackBarMsg: '',
    snackBarType: 'success',
    deviceHasTouch: isDeviceTouch(),
    loadedScrollSections: {},
    setLoadedScrollSections: () => null,
    featureFlags: {
        ordering: isQA || isDev,
    },
};
const App = () => {
    const [, setGlobalState] = useState(initialState);
    const observer = (state) => {
        setGlobalState(state);
    };
    const updateGlobalState = (values) => {
        setGlobalState((prevState) => {
            observable.publish({ ...prevState, ...values });
            return { ...prevState, ...values };
        });
    };
    // globalized the setLoadedScrollSectionFunction
    const initScroll = (sections) => {
        updateGlobalState({ loadedScrollSections: sections });
    };
    // need to keep things in sync to keep new modded object
    const initialStateWithScroll = {
        ...initialState,
        setLoadedScrollSections: initScroll,
    };
    // Setup sub
    useEffect(() => {
        observable.subscribe(observer);
        observable.publish({ ...initialStateWithScroll }); // Publish the initial state only once
        return () => {
            observable.unsubscribe(observer);
        };
    }, []);
    return (_jsx(AppInsightsContext.Provider, { value: reactPlugin, children: _jsx(NavigationManager, { appName: 'MainUI', children: _jsx(I18nextProvider, { i18n: i18n, defaultNS: 'translation', children: _jsx(GlobalStateContextProvider, { initialGlobalState: initialStateWithScroll, children: _jsx(CustomErrorBoundary, { isPageLevel: true, children: _jsxs(ThemeVarProvider, { theme: Theme, children: [_jsx(CssBaseline, {}), _jsx(WrappedRoutes, {})] }) }) }) }) }) }));
};
export const WrappedRoutes = () => {
    const { globalState } = useGlobalStateContext();
    useScrollTo([
        Object.keys(globalState.loadedScrollSections).length,
        Object.values(globalState.loadedScrollSections).every((item) => item),
    ], 58);
    return (_jsx("div", { id: 'microfrontend-div', children: _jsxs(Suspense, { fallback: _jsx(LoadingPage, {}), children: [_jsx(GlobalDataLayer, { merchant_id: localStorage.getItem('idi-merchant-no') || '', email: localStorage.getItem('idi-merchant-username') || '' }), globalState.isAuthenticated && (_jsx(LoginTracking, { merchant_id: localStorage.getItem('idi-merchant-no') || '', email: localStorage.getItem('idi-merchant-username') || '' })), _jsx(AppRoutes, {})] }) }));
};
export default App;
